import { Injectable } from '@angular/core';
import { InspectionService } from '../inspection/inspection.service';
import { VersionService } from '../version/version.service';
import { Answer, InspectionItem, ItemInfo } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class MergeAnswersService {
  constructor(
    public versionService: VersionService,
    public inspectionService: InspectionService,
  ) {}

  items: Array<InspectionItem & { info?: ItemInfo; label?: string; index?: number }>;
  answers: Answer[] = [];
  rawSections: any;
  rawItems;
  any;
  config = {
    sorting: 'none',
    hideWithoutComments: false,
    hideWithoutFlags: false,
    followConfigurationOrder: true,
    items: [0],
    sections: [0],
  };

  async loadItems(inspection, answers) {
    const ret = [];

    this.answers = answers;

    const items: Array<InspectionItem & { info?: ItemInfo; label?: string; index?: number }> = (
      await this.versionService.tree(inspection.versionId)
    ).items;

    this.rawItems = items;

    items.forEach(item => {
      item.info = inspection.items.find(i => i.itemId === item.id);

      if (!item.info) {
        return;
      }

      if (item.info.quantity === 1) {
        const customName = item.info.names && item.info.names[0];
        const defaultName = item.name;
        const label = customName ? `${customName} (${defaultName})` : defaultName;

        for (const section of item.sections) {
          section['questionsHasAnswer'] = section.questions.some(
            question => !!this.answers.find(answer => answer.questionId === question.id),
          );
        }
        ret.push({
          ...item,
          label,
          index: null,
        });
      } else if (item.info.quantity > 1) {
        for (let i = 0; i < item.info.quantity; i++) {
          const customName = item.info.names && item.info.names[i];
          const defaultName = `${item.name} # ${i + 1}`;
          const label = customName ? `${customName} (${defaultName})` : defaultName;

          for (const section of item.sections) {
            section['questionsHasAnswer'] = section.questions.some(
              question => !!this.answers.find(answer => answer.questionId === question.id),
            );
          }

          ret.push({
            // deep copy
            ...JSON.parse(JSON.stringify(item)),
            label,
            index: i + 1,
          });
        }
      }
    });

    return ret;
  }

  // tslint:disable: forin
  mergeAnswers(items) {
    for (const iItem in items) {
      const item = items[iItem];
      const sections = item.sections;
      const buildingIndex = item.index;

      for (const iSection in sections) {
        const section = sections[iSection];
        const questions = section.questions;
        section.item = item;

        for (const iQuestion in questions) {
          const question = questions[iQuestion];
          question.section = section;

          if (question.repeat && question.repeat.length) {
            question.repeat.forEach(itemId => {
              const filteredAnswers = this.answers.filter(ans => {
                return ans.questionId === question.id;
              });
              filteredAnswers.forEach(a => (a.question = question));
              question.answer = filteredAnswers;
            });
          } else {
            const answer = this.answers.find(ans => {
              const indexOk = !buildingIndex || ans.buildingIndex === buildingIndex;
              return ans.questionId === question.id && indexOk;
            });
            if (answer) {
              answer.question = question;
              question.answer = answer;
            }
          }
        }
      }
    }
  }
}
